import React from "react";

import { Button, Container, Form } from "reactstrap";
import BaseInput from "../../../toolkit/baseInput";
import ModalFrame from "../../../toolkit/modalFrame";
import { PROSPECT_NO_BUY_REASON } from "../../../types-business/User";
import { handleRequestError } from "../../../utils/helpers";
import { patchProspectNoBuyReason } from "../../actions/prospects";

const options = [
  { value: "DISTANCIA_DEL_CLUB", label: "Distancia del club" },
  {
    value: "YA_CUENTA_CON_MEMBRESIA_O_ID",
    label: "Ya cuenta con membresía o Id"
  },
  { value: "OFERTA_DEPORTIVA", label: "oferta deportiva" },
  { value: "COSTO", label: "Costo" },
  {
    value: "MANTENIMIENTO_INSTALACIONES",
    label: "Mantenimiento de instalaciones"
  },
  { value: "NO_PIDIO_INFORMACION", label: "No pidió información" },
  { value: "DATOS_FALSOS", label: "Datos falsos" },
  { value: "ILOCALIZABLE", label: "Ilocalizable" }
];

interface Prospect {
  personaId: string;
  motivoNoCompra: PROSPECT_NO_BUY_REASON;
}

interface Props {
  isOpen: boolean;
  prospect: Prospect;
  onOk: () => void;
  onCancel: () => void;
}

interface State {
  fields: {
    motivoNoCompra: PROSPECT_NO_BUY_REASON;
  };
}

class ProspectNoBuyReasonModal extends React.Component<Props, State> {
  state = {
    fields: {
      motivoNoCompra: PROSPECT_NO_BUY_REASON.DISTANCIA_DEL_CLUB
    }
  };

  onChangeFactory = fieldName => {
    return event => {
      const value = event.target.value;
      this.setState(state => {
        const fields = {
          ...state.fields,
          [fieldName]: value
        };
        return { ...state, error: {}, fields };
      });
    };
  };

  clearState = () => {
    const { fields } = this.state;
    fields.motivoNoCompra = PROSPECT_NO_BUY_REASON.DISTANCIA_DEL_CLUB;
    this.setState({ fields: { ...fields } });
  };

  onOkButton = () => {
    const data = { motivoNoCompra: this.state.fields.motivoNoCompra };

    patchProspectNoBuyReason(this.props.prospect.personaId, data)
      .then(() => {
        this.clearState();
        if (!!this.props.onOk) {
          this.props.onOk();
        }
      })
      .catch(handleRequestError);
  };

  onCancelButton = () => {
    this.clearState();

    if (!!this.props.onCancel) {
      this.props.onCancel();
    }
  };

  render() {
    return (
      <ModalFrame
        title={"Cambiar motivo de no compra"}
        isOpen={this.props.isOpen}
        toggle={() => {
          this.onCancelButton();
        }}
      >
        <Container>
          <Form>
            <BaseInput
              label={"Motivo de no compra"}
              name={"noBuyReason"}
              type="select"
              id={"noBuyReason"}
              value={this.state.fields.motivoNoCompra}
              options={[...options]}
              onChange={this.onChangeFactory("motivoNoCompra")}
            />

            <Button
              disabled={!this.state.fields.motivoNoCompra}
              block
              onClick={() => {
                this.onOkButton();
              }}
            >
              ACEPTAR
            </Button>
          </Form>
        </Container>
      </ModalFrame>
    );
  }
}

export default ProspectNoBuyReasonModal;
